module.exports = __webpack_public_path__ + "static/yahoobg2-e5122172ce3b79d56cc09789535bccf7.jpg";